import API from './index';

const api = {
    getFinalDetail(params) {
        return API.authAPI({
            url: '/approval/get-final-detail',
            method: 'GET',
            params: { ...params },
        });
    },
    saveFinalReport(data) {
        return API.authAPI({
            url: '/approval/save-final',
            method: 'POST',
            data,
        });
    },
    submitFinalReport(data) {
        return API.authAPI({
            url: '/approval/submit-final',
            method: 'POST',
            data,
        });
    },
};

export default api;
